$(() => {
    // Load temperature data on page load if block exists
	if ($('.block.temperature-tracker').length) {
        get_temperature_data()
	}

    /**
     * Get Temperature Data
     */
    function get_temperature_data() {
        var parent = $('.block.temperature-tracker');
        if (!parent.length) return false;
        var container = parent.find('.data');
        if (!container.length) return false;

        // Remove existing items in the container
        container.empty();

        // Show loading
        parent.find('.loading').addClass('active');

        // Grab the posts via Ajax
        $.ajax({
            type: 'POST',
            url: ajaxurl,
            dataType: 'json',
            data: { 
                action: 'get_temperature_data',
            },
            success: function(response) {
                
                // Error message
                if (!response.success) {
                    console.log(response.message);
                    return false;
                }

                var data = response.data;

                // Show no data message
                if (!data.length) {
                    container.append('<p>Temperature data could not be retreived at this time. The domain of the data source may be offline.</p>');
                }

                // Loop through the data
                else {
                    container.append(data);
                    $(window).scroll();
                }

                // Hide loading
                parent.find('.loading').removeClass('active');
            }
        });
    }
})